var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8856 6.28213V2.40595C16.7308 2.40595 16.608 1.83417 16.608 1.83417C16.608 1.51847 16.2065 1.26239 15.7113 1.26239H8.61897C8.12375 1.26239 7.72225 1.51847 7.72225 1.83417C7.72225 1.83417 7.60191 2.40595 8.44495 2.40595V6.28235C6.77185 6.59959 5.51191 7.99175 5.51191 9.66133V18.2842C5.51191 19.7457 6.47771 20.9935 7.84039 21.4953V23.2624H16.4895V21.4953C17.8521 20.9937 18.8182 19.7457 18.8182 18.2842V9.66133C18.8184 7.99175 17.5584 6.59959 15.8856 6.28213ZM10.6465 3.03273H15.2718V5.63291H10.6465V3.03273ZM14.4604 22.2596H9.86967C9.47961 22.2596 9.14433 22.0412 8.99231 21.7272C9.05171 21.7299 9.11111 21.7314 9.17095 21.7314H15.1589C15.2187 21.7314 15.2784 21.7299 15.3375 21.7272C15.1857 22.0412 14.8507 22.2596 14.4604 22.2596Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasStorage);
export default __webpack_public_path__ + "static/media/gas-storage.de0cde2931c5dc19e1eb68ce37ae95dd.svg";
export { ForwardRef as ReactComponent };